export default function LoadingOverlay() {
  return (
     <div style={{
        position: "fixed",
        inset: 0,                      // top:0; right:0; bottom:0; left:0
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0,0.4)", // 40% opacity black
        zIndex: 99999,
      }}
      aria-hidden="true">
      <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}